import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ReactFlowProvider } from 'reactflow';
import { AuthProvider } from './contexts/AuthContext';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import Home from './pages/Home';
import Channels from './pages/Channels';
import MessageHistory from './pages/MessageHistory';
import ChatbotFlows from './pages/ChatbotFlows';
import ChatbotBuilder from './pages/ChatbotBuilder';
import Campaigns from './pages/Campaigns';
import CreateCampaign from './pages/CreateCampaign';
import Contacts from './pages/Contacts';
import ConnectWhatsApp from './pages/ConnectWhatsApp';
import SignupSuccess from './pages/SignupSuccess';
import Profile from './pages/Profile';
import Help from './pages/Help';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/signup-success" element={<SignupSuccess />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Layout>
                  <Dashboard />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/channels"
            element={
              <ProtectedRoute>
                <Layout>
                  <Channels />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <Layout>
                  <Profile />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/help"
            element={
              <ProtectedRoute>
                <Layout>
                  <Help />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/connect-whatsapp"
            element={
              <ProtectedRoute>
                <ConnectWhatsApp />
              </ProtectedRoute>
            }
          />
          <Route
            path="/history/:instanceId"
            element={
              <ProtectedRoute>
                <Layout>
                  <MessageHistory />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/chatbot/:instanceId"
            element={
              <ProtectedRoute>
                <Layout>
                  <ChatbotFlows />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/chatbot/:instanceId/editor/:flowId"
            element={
              <ProtectedRoute>
                <ReactFlowProvider>
                  <ChatbotBuilder />
                </ReactFlowProvider>
              </ProtectedRoute>
            }
          />
          <Route
            path="/contacts"
            element={
              <ProtectedRoute>
                <Layout>
                  <Contacts />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/contacts/:instanceId"
            element={
              <ProtectedRoute>
                <Layout>
                  <Contacts />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/campaigns"
            element={
              <ProtectedRoute>
                <Layout>
                  <Campaigns />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/campaigns/new"
            element={
              <ProtectedRoute>
                <Layout>
                  <CreateCampaign />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/campaigns/:instanceId"
            element={
              <ProtectedRoute>
                <Layout>
                  <Campaigns />
                </Layout>
              </ProtectedRoute>
            }
          />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;